import { createNavigation } from "next-intl/navigation"
import { defineRouting } from "next-intl/routing"

/* Can be imported from a shared config.

   EGDE-669: English was discarded from the site — dropping it here is what makes
   `/en/...` unroutable (middleware.ts 301s the old URLs to their Hebrew
   equivalents so bookmarks and external links don't land on a 404). */
export const locales = ["he", "ar", "ru"] as const

export const routing = defineRouting({
  locales: locales,

  // If this locale is matched, pathnames work without a prefix (e.g. `/about`)
  defaultLocale: "he",
  localeDetection: false,
  localePrefix: "as-needed",
  alternateLinks: false,
})

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { Link, redirect, usePathname, useRouter } =
  createNavigation(routing)
